// AgeVerifier.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import { ButtonId } from '../resource/mixpanel.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import AdultOnlyIconSource from '../../img/img-under-18.svg';
import { color } from '../style/variables.js';

export class AgeVerifier extends React.PureComponent {
  state = { isServer: true };
  nextTick = null;

  componentDidMount() {
    this.nextTick = setTimeout(() => this.setState({ isServer: false }), 0);
  }

  componentWillUnmount() {
    clearTimeout(this.nextTick);
  }
  renderDescription() {
    const { t } = this.props;
    const explode = t('age_verify_description', {
      ns: TranslationNamespace.GENERAL,
    })
      .replace(/(terms_of_service)/g, '__$1__')
      .split('__');
    return (
      <ContentDescription>
        {explode.map((s, index) =>
          'terms_of_service' === s ? (
            <a href="https://swag.live/terms_of_service" key={index}>
              {t('terms_of_service', {
                ns: TranslationNamespace.GENERAL,
              })}
            </a>
          ) : (
            s
          )
        )}
      </ContentDescription>
    );
  }

  render() {
    const { isServer } = this.state;
    const { t } = this.props;
    return (
      !isServer && (
        <Wrapper onScroll={e => e.stopPropagation()}>
          <StyledAgeVerifier>
            <AdultOnlyIcon src={AdultOnlyIconSource} alt="adult only icon" />

            <ContentTitle>
              {t('age_verify_title', {
                ns: TranslationNamespace.GENERAL,
              })}
            </ContentTitle>
            {this.renderDescription()}
            <Options>
              <GuestEnterButton
                onClick={this.props.submitAnonymousLogin}
                data-element_id={ButtonId.All.ButtonGuestModeEnter}
              >
                {t('button_enter_as_guest_18', {
                  ns: TranslationNamespace.GENERAL,
                })}
              </GuestEnterButton>
              <AccountEnterButton
                onClick={this.props.login}
                data-element_id={ButtonId.LoginRegister.ButtonLogin}
              >
                {t('button_sign_up_log_in', {
                  ns: TranslationNamespace.GENERAL,
                })}
              </AccountEnterButton>
              <Exit
                href="https://www.google.com/search?q=grow up"
                title="exit"
                data-element_id={ButtonId.All.ButtonExitSWAG}
              >
                {t('button_under_18_leave', {
                  ns: TranslationNamespace.GENERAL,
                })}
              </Exit>
            </Options>
          </StyledAgeVerifier>
        </Wrapper>
      )
    );
  }
}

AgeVerifier.propTypes = {
  t: PropTypes.func.isRequired,
  login: PropTypes.func,
  submitAnonymousLogin: PropTypes.func,
};

AgeVerifier.defaultProps = {
  login: () => null,
  submitAnonymousLogin: () => null,
};

const Wrapper = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: none;
  padding: 8px;
  color: black;
  background-color: rgba(0, 0, 0, 1);
  z-index: 1000;
`;

const StyledAgeVerifier = styled.div`
  position: absolute;
  transform: translate(-50%, -50%);
  top: calc(50% + 25px);
  left: 50%;
  padding: 24px 24px 16px 24px;
  max-width: 300px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #232323;
  border-radius: 8px;
`;

const AdultOnlyIcon = styled.img`
  width: auto;
  height: 100px;
`;

const ContentTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  line-height: 150%;
  font-weight: 600;
  color: #fff;
  padding-top: 24px;
`;

const ContentDescription = styled.p`
  margin: 8px 0px 0px;
  width: 100%;
  font-size: 12px;
  font-weight: 200;
  text-align: center;
  line-height: 20px;
  white-space: pre-line;
  overflow: auto;
  color: #646464;
  max-height: 140px;
  overflow-y: scroll;
  & > a {
    text-decoration: underline;
  }
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Options = styled.div`
  padding-top: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Exit = styled.a`
  display: block;
  text-align: center;
  color: #c8c8c8;
  font-size: 12px;
  line-height: 200%;
  padding: 2px 8px;
`;

const Enter = styled.button`
  outline: none;
  border: 0px;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 14px;
  line-height: 200%;
  font-weight: 600;
  width: 100%;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
`;

const GuestEnterButton = styled(Enter)`
  background-color: ${color.neutral[100]};
  color: ${color.neutral[0]};
`;

const AccountEnterButton = styled(Enter)`
  border: 1px;
  border-color: ${color.neutral[20]};
  border-style: solid;
  color: ${color.white};
`;

export default withTranslation()(AgeVerifier);
